function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react'; //import { ResponsivePie } from '@nivo/pie'

import { ResponsivePie } from './pie';
import "./ChartLine.scss";
import PieTooltip from "./ChartPieTooltip";
import PieLegend from "./ChartPieLegend";

class ChartPie extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getProps", () => {
      const renderTooltip = this.props.renderTooltip;
      return _extends({}, this.props);
    });

    _defineProperty(this, "renderTooltip", slice => {
      const _this$props = this.props,
            data = _this$props.data,
            colors = _this$props.colors;

      if (this.props.renderTooltip) {
        return this.props.renderTooltip({
          data: data,
          colors: colors,
          slice: slice
        });
      }

      return React.createElement(PieTooltip, _extends({}, this.props, {
        slice: slice
      }));
    });
  }

  render() {
    const props = this.getProps();
    return React.createElement(ResponsivePie, props);
  }

}

_defineProperty(ChartPie, "defaultProps", {
  data: [],
  theme: {},
  innerRadius: 0.25,
  padAngle: 1,
  cornerRadius: 0,
  borderWidth: 0,
  enableRadialLabels: false,
  enableSlicesLabels: false,
  sortByValue: false,
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  animate: false,
  isInteractive: true
});

export default ChartPie;